<template>
  <div class="index-box">
     <div class="index-content">
      <div class="banner-box">
        <img :src="banner"/>
      </div>
      <div class="resource-box">
        <div class="resource-box-content">
          <div class="resource-box-head">
            <p class="index-title-box">版权资源库 </p>
            <span @click="goToResource">更多了解></span>
          </div>
          <div class="resource-list">
            <div class="resource_item" v-for="item in resourceList"  :key="item.id" @click="goToDetail(item)">
              <div class="resource_item-img" @mouseover="handelMouseOver">
                  <span class="resource_item-img-tag" :style="`background:${!item.confirmStatus ? '#d9d9d9' : item.confirmStatus == 1? '#00BB0D ' : '#FFDB00'}`">{{!item.confirmStatus ? '未确权' : item.confirmStatus == 1 ? '确权通过' : item.confirmStatus == 2 ? '确权中':''}}</span>
                  <div class="image-background" :style="`backgroundImage:url(${item.placard})`" ></div>
              </div>
              <div class="resource_item-des">
                  <p>{{item.copyrightName}}</p>
                  <p class="resource_item-des2">{{item.summary}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-content">
          <div class="data-box-item data-box-left">
            <h2>运营收入分析</h2>
            <div class="data-box-bg"></div>
            <div class="data-box-echart">
              <ve-line :data="chartData"></ve-line>
            </div>
            <!-- <div class="data-box-btn">点击进入</div> -->
          </div>
          <div class="data-box-item data-box-right">
            <h2>侵权统计分析</h2>
            <div class="data-box-bg"></div>
            <div class="data-box-echart">
              <ve-pie :data="pieData" :settings="chartSettings"></ve-pie>
            </div>
            <!-- <div class="data-box-btn">点击进入</div> -->
          </div>
        </div>
        
      </div>
      <div class="group-box">
        <div class="group-box-content">
          <div class="group-box-head">
            <p class="index-title-box" style="398px">优质运营团队</p>
          </div>
          
          <div class="group-list" style="min-height: 400px;">
            <div class="group_item" v-for="item in groupList" :key="item.id">
              <div class="group_item-img" @mouseover="handelMouseOver">
                  <div class="image-background" :style="`backgroundImage:url(${item.src})`"  @click="goDetail"></div>
              </div>
              <div class="group_item-des">
                  <p>{{item.title}}</p>
                  <p class="group_item-des2">{{item.team}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getCopyrightListIndex} from "../../api/copyright"
export default {
  data() {
    this.chartSettings = {
      dimension: '日期',
      metrics: '访问用户'
    }
    return {
      banner: require("../../assets/banner.png"),
      resourceList: [],
      groupList: [
        {
          id:1,
          src: require('../../assets/hanhai.jpg'),
          title: '北京涵海影业有限公司',
          team: ''
        },
        {
          id:2,
          src: require('../../assets/xingkong.jpg'),
          title: '北京星空盒子文化传播有限公司',
          team: ''
        },
        {
          id:3,
          src: require('../../assets/yashi.jpg'),
          title: '北京亚视联合文化发展有限公司',
          team: ''
        },{
          id:4,
          src: require('../../assets/zhongcongInternet.jpg'),
          title: '成武众从网络科技有限公司',
          team: ''
        },{
          id:5,
          src: require('../../assets/xingtan.jpg'),
          title: '福州星潭文化发展有限公司',
          team: ''
        },{
          id:6,
          src: require('../../assets/jingyue.jpg'),
          title: '合肥鲸悦文化传媒有限公司',
          team: ''
        },{
          id:7,
          src: require('../../assets/xiaohongmao.jpg'),
          title: '河南省小红帽文化传媒有限公司',
          team: ''
        },{
          id:8,
          src: require('../../assets/aiwate.jpg'),
          title: '湖南艾瓦特网络科技有限公司',
          team: ''
        },{
          id:9,
          src: require('../../assets/yuying.jpg'),
          title: '福州御应传媒有限公司',
          team: ''
        },{
          id:10,
          src: require('../../assets/lebo.jpg'),
          title: '江西乐播文化传媒有限公司',
          team: ''
        },{
          id:11,
          src: require('../../assets/kuo.jpg'),
          title: '南昌酷哦文化传播有限公司',
          team: ''
        },{
          id:12,
          src: require('../../assets/xinsheng.jpg'),
          title: '厦门昕笙文化传媒有限公司',
          team: ''
        },{
          id:13,
          src: require('../../assets/youcaiwenhua.jpg'),
          title: '陕西优才文化传播有限公司',
          team: ''
        },{
          id:14,
          src: require('../../assets/xinze.jpg'),
          title: '商丘鑫泽众文化传播有限公司',
          team: ''
        },{
          id:15,
          src: require('../../assets/miaobi.jpg'),
          title: '苏州妙笔网络科技有限公司',
          team: ''
        },{
          id:16,
          src: require('../../assets/wance.jpg'),
          title: '武汉万策文化传播有限公司',
          team: ''
        },
      ],
     
      chartData: {
            legendName:'某版权运营收入分析统计',
            columns: ['月份', '收益'],
            rows: [
              { '月份': 'Jan', '收益': 5.6 },
              { '月份': 'Feb', '收益': 1500 },
              { '月份': 'Mar', '收益': 2600 },
              { '月份': 'Apr', '收益': 3614 },
              { '月份': 'May', '收益': 5300 },
              { '月份': 'Jun', '收益': 8600 },
              { '月份': 'Jul', '收益': 12356 },
              { '月份': 'Aug', '收益': 13000 },
              { '月份': 'Sep', '收益': 12554 },
              { '月份': 'Oct', '收益': 9844 },
              { '月份': 'Nov', '收益': 7863 },
              { '月份': 'Dec', '收益': 4321 },
            ]
          },
      chartSettings: {
        offsetY:200
      },
      pieData: {
          legendName:'某版权侵权分析统计',
          columns: ['来源', '比例'],
          rows: [
            { '来源': '西瓜视频', '比例': 8 },
            { '来源': 'bilibili', '比例': 14 },
            { '来源': '好看视频', '比例': 9 },
            { '来源': '看点视频', '比例': 28 },
            { '来源': '天天快报', '比例': 4 },
            { '来源': '土豆视频', '比例': 37 },
          ]
        }
    }
  },
  name:'index',
  components:{
  },
  watch:{
    $route( to , from ){   
       console.log(to,from)
     }
  },
  mounted(){
    this.getCopyrightListIndexFun()
  },
  methods: {
    handelMouseOver(){

    },
    goToDetail(data){
      const {href} = this.$router.resolve({
          path: "/detail",
          query:{id:data.copyrightId, type:'resource'}
      });
      window.open(href, '_blank');
    },
    getCopyrightListIndexFun(){
      getCopyrightListIndex().then(res => {
        if(res.code == 200) {
          this.resourceList = res.result
        }
        
      })
    },
    goDetail(){},
    goToResource(){
      this.$router.push("/resource");
    },
    goToIndex(){
      window.location.href="/"
    }
    
  }
}

</script>
<style lang="stylus" scoped>
    .index-box{
      width 100%
      background black
    }
    .index-content{
        min-width 1334px
        margin 0 auto
        background black
        .banner-box{
          width 100%
          display flex
          img{
            width 100%
            // height 805px
          }
          //汉仪晓波花月圆

        }
        .resource-box{
          width 100%
          margin-bottom 100px
          background black 
          .resource-box-content{
            width 1334px
            height auto
            min-height 200px
            margin  0 auto 
            .resource-box-head{
              width 100%
              height 232px
              margin 0 auto
              display flex
              align-items center
              justify-content space-around
              position relative
              
              span{
                font-size: 14px;
                color: #CDCDCD;
                height 14px
                position absolute
                right 0
                top 109px
                cursor pointer
              }
              
              
            }
          }
        }
        .resource-list{
          min-height 650px
          width 100%
          display flex
          flex-wrap wrap
        }
        .resource_item{
          height 394px
          width 250px
          margin-right 20px
          margin-bottom 30px
          cursor pointer
          .resource_item-img{
              height 332px
              width 250px
              position relative
              .resource_item-img-tag{
                position absolute
                padding 6px
                top 0
                right 5px
                font-size: 14px;
                color: #333333;
                border-radius: 0 0 4px 4px;
              }
          }
          .resource_item-des{
              height 62px
              background: rgba(255,255,255,0.40);
              p{
                padding 0 10px
                height 30px
                line-height 30px
                width 100%
                font-size: 16px;
                color white
                box-sizing border-box
                overflow:hidden; 
                text-overflow:ellipsis; 
                white-space:nowrap; 
              }
              .resource_item-des2{
                font-size 12px
              }
          }
          .image-background{
              width 100%
              height 100%
              display inline-block
              background-repeat no-repeat
              background-size: cover;
              background-position: center;
              -o-background-size: cover;
              -moz-background-size: cover;
              -webkit-background-size:cover;
          }
        }
        .resource_item:nth-child(5n){
          margin-right 0
        }
        .resource_item:nth-child(n+5){
          margin-bottom 0
        }
        .data-box{
          width 100%
          height 746px
          .data-box-content{
            width 1334px
            height 100%
            margin 0 auto
            display flex
            align-items center
            justify-content space-between
            .data-box-item{
              background: #FDDA00;
              width 652px
              height 746px
              position relative
              h2{
                font-family: 'NotoSansHans-Regular';
                font-size: 40px;
                color: #333333;
                text-align center
                height 52px
                line-height 52px
                padding-top 60px
                box-sizing content-box
              }
              .data-box-bg{
                width 488px
                height 301px
                background: rgba(255,255,255,0.32);
                box-shadow: 0 25px 31px 0 #FDBC00;
                position absolute
                top 172px
                right 61px
              }
              .data-box-echart{
                width 499px
                height 352px
                position absolute
                top 194px
                left 61px
                background white
                padding-top 10px
              }
            }
            .data-box-right{
              .data-box-bg{
                left 61px
              }
              .data-box-echart{
                left 92px
              }
            }
            .data-box-btn{
              position absolute
              background: #FFFFFF;
              border-radius: 100px;
              width 200px
              height 40px
              line-height 40px
              text-align center
              cursor pointer
              left 226px
              bottom 60px
              font-size: 18px;
              color: #333333;
            }
          }
        }
        .index-title-box{
            width 358px
            height 52px
            text-align center
            line-height 52px
            color white
            font-size 40px
            font-family "NotoSansHans-Regular"
            position relative
            margin 0 auto
        }
        .index-title-box::before{
          content ""
          width 40px
          height 1px
          background white
          position absolute
          left 0
          top 25px
        }
        .index-title-box::after{
          content ""
          width 40px
          height 1px
          background white
          position absolute
          right 0
          top 25px
        }
        .group-box{
          width 100%
          height auto
          .group-box-content{
            width 1334px
            height auto
            margin 0 auto
            .group-box-head{
              width 100%
              height 232px
              display flex
              align-items center
              justify-content center
            }
            .group-list{
              min-height 650px
              width 100%
              display flex
              flex-wrap wrap
              align-items center
              justify-content space-between
            }
            .group_item{
              height 186px
              width 319pxpx
              cursor pointer
              margin-bottom 20px
              .group_item-img{
                  background white
                  height 128px
                  width 319px
              }
              .group_item-des{
                  height 58px
                  background: rgba(255,255,255,0.40);
                  text-align: center;
                  p{
                    padding-top 20px
                    font-size: 18px;
                    color: #FFFFFF;
                    width 100%
                    overflow:hidden; 
                    text-overflow:ellipsis; 
                    white-space:nowrap; 
                    height 18px
                    line-height 18px
                    box-sizing content-box
                  }
                  .group_item-des2{
                    color: #CDCDCD;
                    padding-top 20px
                  }
              }
              .image-background{
                  width 100%
                  height 100%
                  display inline-block
                  background-repeat no-repeat
                  background-size: cover;
                  -o-background-size: cover;
                  -moz-background-size: cover;
                  -webkit-background-size:cover;
                  background-position: center;
              }
            }

          }
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue